module.exports = __webpack_public_path__ + "img/Chien.f68da31d.jpeg";